type Args = {
  UNIT_ID: string | null;
  CUSTOMER_ID: string | null;
  CUSTOMER_NAME: string | null;
  SENSORBOX_ID: string | null;
  SENSORBOX_HOSTNAME: string | null;
};

export class ArgsService {
  // Private static args object
  private static args: Args = {
    UNIT_ID: null,
    CUSTOMER_ID: null,
    CUSTOMER_NAME: null,
    SENSORBOX_ID: null,
    SENSORBOX_HOSTNAME: null,
  };

  // Initialize the arguments from process.argv or other sources
  public static initialize(rawArgs: Record<string, string | null>): void {
    // Update individual keys without reassigning the entire object
    for (const key in rawArgs) {
      if (key in ArgsService.args) {
        ArgsService.args[key as keyof Args] = rawArgs[key];
      }
    }
  }

  // Get a specific argument
  public static getArg(key: string): string | null {
    if (key in ArgsService.args) {
      return ArgsService.args[key as keyof Args];
    }
    return null;
  }

  // Get all arguments
  public static getArgs(): Args {
    return { ...ArgsService.args }; // Return a copy to maintain immutability
  }
}
